import React from 'react';

import { capitalize } from 'lodash';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import * as classes from './FaultByPriorityFilter.module.css';

const FaultByPriorityFilter = ({
    faultFilters,
    setFaultFilters,
    ...props
}) => {

    const MenuProps = {
        classes:            { paper: classes.paper },
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 225,
                width:     250,
                top:       39,
                left:      194
            },
        },
    };

    const handleChangeFilter = (event) => {
        setFaultFilters(event.target.value);
    };

    return (
        <Select
            labelId="demo-mutiple-checkbox-label"
            id="demo-mutiple-checkbox"
            className={classes.MultiSelect}
            multiple
            input={
                <Input
                    className={{
                        underline: classes.underline,
                    }}
                />
            }
            value={faultFilters}
            onChange={handleChangeFilter}
            renderValue={(selected) => selected.map(type => capitalize(type)).join(', ')}
            MenuProps={MenuProps}
            variant="filled"
        >
            <MenuItem key={0} value={'low'}>
                <Checkbox
                    classes={{
                        root: classes.Checkbox
                    }}
                    style={{ color: 'black' }}
                    checked={faultFilters.map(filter => filter).indexOf('low') > -1}
                />
                <ListItemText className={classes.Font} primary={'Low'} />
            </MenuItem>
            <MenuItem key={1} value={'medium'}>
                <Checkbox
                    classes={{
                        root: classes.Checkbox
                    }}
                    style={{ color: 'black' }}
                    checked={faultFilters.map(filter => filter).indexOf('medium') > -1}
                />
                <ListItemText className={classes.Font} primary={'Medium'} />
            </MenuItem>
            <MenuItem key={2} value={'high'}>
                <Checkbox
                    classes={{
                        root: classes.Checkbox
                    }}
                    style={{ color: 'black' }}
                    checked={faultFilters.map(filter => filter).indexOf('high') > -1}
                />
                <ListItemText className={classes.Font} primary={'High'} />
            </MenuItem>
        </Select>
    );
};

export default FaultByPriorityFilter;
